import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';

/**
 * Panel dropdown de notificaciones (últimas 20)
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Si el panel está visible
 * @param {Function} props.onToggle - Toggle del panel
 * @returns {JSX.Element|null}
 */
function NotificationPanel({ isOpen, onToggle }) {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleClick = async (notif) => {
    if (!notif.leida) {
      await markAsRead(notif.id);
    }
    onToggle(false);
    if (notif.referencia_tipo === 'orden_trabajo' && notif.referencia_id) {
      navigate(`/mis-ordenes-trabajo/${notif.referencia_id}`);
    }
  };

  const handleMarkAll = async () => {
    await markAllAsRead();
  };

  const formatTime = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return 'Ahora';
    if (diffMin < 60) return `${diffMin}m`;
    const diffHrs = Math.floor(diffMin / 60);
    if (diffHrs < 24) return `${diffHrs}h`;
    const diffDays = Math.floor(diffHrs / 24);
    return `${diffDays}d`;
  };

  const tipoIcon = {
    ot_asignada: 'fa-user-plus',
    ot_vencida: 'fa-exclamation-triangle',
    ot_completada: 'fa-check-circle',
    ot_reprogramada: 'fa-calendar-alt'
  };

  return (
    <div className="notif-panel">
      <div className="notif-header">
        <h4>Notificaciones</h4>
        {unreadCount > 0 && (
          <button className="btn btn-sm" onClick={handleMarkAll}>
            Marcar todas
          </button>
        )}
      </div>
      <div className="notif-list">
        {notifications.length === 0 ? (
          <div className="notif-empty">Sin notificaciones</div>
        ) : (
          notifications.map(notif => (
            <button
              key={notif.id}
              className={`notif-item ${!notif.leida ? 'notif-unread' : ''}`}
              onClick={() => handleClick(notif)}
            >
              <i className={`fas ${tipoIcon[notif.tipo] || 'fa-bell'} notif-icon`}></i>
              <div className="notif-content">
                <span className="notif-title">{notif.titulo}</span>
                <span className="notif-message">{notif.mensaje}</span>
              </div>
              <span className="notif-time">{formatTime(notif.created_at)}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}

export default NotificationPanel;
